import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=425af6f6&scoped=true"
import script from "./Dashboard.ts?vue&type=script&lang=js&external"
export * from "./Dashboard.ts?vue&type=script&lang=js&external"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=425af6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425af6f6",
  null
  
)

export default component.exports